import { CreateBookingData } from "@/lib/validation/booking";
import { create } from "zustand";

interface CreateRequestState {
    formData: Partial<CreateBookingData>;
    currentStep: number;
    hasReg: boolean;
    setFormData: (data: Partial<CreateBookingData>) => void;
    setCurrentStep: (step: number) => void;
    setHasReg: (hasReg: boolean) => void;
    resetForm: () => void;
}

export const useCreateRequestStore = create<CreateRequestState>((set) => ({
    formData: {
        service_type: "breakdown_recovery",
        passenger_count: 0,
        pet_count: 0,
        payment_method: "card",
    },
    currentStep: 0,
    hasReg: false,
    setFormData: (data) =>
        set((state) => ({
            formData: { ...state.formData, ...data },
        })),
    setCurrentStep: (step) => set({ currentStep: step }),
    setHasReg: (hasReg) => set({ hasReg }),
    resetForm: () =>
        set({
            formData: {
                service_type: "breakdown_recovery",
                passenger_count: 0,
                pet_count: 0,
                payment_method: "card",
            },
            currentStep: 1,
            hasReg: false,
        }),
}));
